<template #cell(actions)>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header row">
            <div class="card-header fw-bold col-sm-6 report-title">
              Report of Adoption Status              
            </div>
            <div class="card-header btn-clstyle col-sm-6 p-2">
              <button type="button" class="btn btn-primary me-2" @click="download()">
                <span class="material-icons-outlined btn-icon"> download </span>
                Download
              </button>
              <button type="button" class="btn btn-outline-danger me-2" @click="$emit('close', false)">
                <span class="material-icons-outlined btn-icon"> cancel </span>
                Close
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div class="table-responsive p-1">
              <table class="table le-f">
                <thead class="thead-dark le-gh ">
                  <tr>
                   <!-- <th>Status</th>  -->
                    <th>Message</th>
                    <th>Term</th>
                    <th>Course</th>
                    <th>Section</th>
                    <th>ISBN</th>
                    <th>Book Title</th>
                    <th>Authors</th>
                    <th>Edition</th>
                    <th>Publisher</th>
                    <th>Adoption Type</th>
                    <!-- <th>Suggestion Type</th>
                    <th>Notes</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in validationResults" :key="index"
                    :class="[(item.validationResult == 'Success') ? greenBg : redBg]">
                    <!-- <td>{{ item.validationResult }}</td> -->                    
                    <td>{{ item.validationMessage }}</td>
                    <td>{{ item.termCSV }}</td>
                    <td>{{ item.courseNumberCSV }}</td>
                    <td>{{ item.sectionNumberCSV }}</td>
                    <td>{{ item.bookIdCSV }}</td>
                    <td>{{ item.bookTitleCSV }}</td>
                    <td><p v-for="(author,index) in item.authorsCSV" :key="index">{{author}}</p></td>
                    <td>{{ item.editionCSV }}</td>
                    <td>{{ item.publisherCSV }}</td>
                    <td>{{ item.adoptionTypeCSV }}</td>
                    <!-- <td>{{ item.adoptionTypeCSV }}</td>
                    <td>{{ item.notesCSV }}</td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
  
<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable'
export default {
  
  name: "CsvValidationsResult",
  components: {},
  data() {
    return {
      redBg: 'redBg',
      greenBg: 'greenBg'
    };
  },
  props: {
    validationResults: [],
   
  },
  methods: {
    cellStyle(value, index) {
      console.log(value, "vali", index, "indexinxs")
      return {
        classes: value.trim() === 'YES' ? 'yes' : 'no'
      };
    },
    download(){
      
      const doc = new jsPDF({orientation: 'landscape'}); 
      const tableHeaders = ['Status','Message','Term','Course','Section',"ISBN","Book Title","Authors","Adoption Type"]
      const tableData = []
  this.validationResults.forEach(item => {
    tableData.push([item.validationResult,
                    item.validationMessage,
                    item.termCSV, 
                    item.courseNumberCSV,
                    item.sectionNumberCSV,
                    item.bookIdCSV,
                    item.bookTitleCSV,
                    item.authorsCSV,
                    item.adoptionTypeCSV
                  ])
  })
  const columnWidth = [10,20,10,10,10,10,10,10,10]
  doc.autoTable({
    
    head: [tableHeaders],
    body: tableData, 
    columnWidth: columnWidth, 
  })      
      doc.save('TextBookOPAdoptionsReport.pdf');
      console.log("download")
    }

  },
  mounted() {
      
  },
};
</script>
  
<style scoped>
.report-title{
  text-align: center;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.redBg {
  background-color: rgb(255 224 224) !important;
}

.greenBg {
  background-color: rgb(225 251 225);
}
.le-f > tbody > tr> td {
    font-size: 13px;
}

.le-f{
  position: sticky;
}
.le-gh{
  font-size: 13px;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  overflow-y: auto;
  width: 86%;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
  position: fixed;
}

.modal-body {
  margin: 20px 0;
  height: 370px;
  padding-top: 0;
}

.btn-clstyle {
  padding: 20px;
  vertical-align: revert;
  display: flex;
  align-items: end;
  justify-content: end
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.card-header {
  width: 100%
}
</style>